module.exports = __webpack_public_path__ + "static/media/vw-transporter3.62324c79.webp";